import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["deleteOverlay", "cloneOverlay"]

    showDelete(event) {
        if (confirm("Are you sure you want to delete this?")) {
            const turboFrame = document.getElementById(event.currentTarget.dataset.target);
            turboFrame.classList.add("hidden");
            this.deleteOverlayTarget.classList.remove("hidden");
        } else {
            event.preventDefault()
        }
    }

    showClone(event) {
        if (confirm("Are you sure?")) {
            let onlyClone = event.currentTarget.dataset.onlyClone;

            if (!onlyClone) {
                const turboFrame = document.getElementById(event.currentTarget.dataset.target);
                turboFrame.classList.add("hidden");
            }

            this.cloneOverlayTarget.classList.remove("hidden");
        } else {
            event.preventDefault();
        }
    }



    showLoader(event) {
        if (event.target.checked) {
            const reportsLoader = this.element.querySelector('#reports_loader')
            const hiddenLoader = this.element.querySelector('#hidden_loader')
            reportsLoader.innerHTML = hiddenLoader.innerHTML
        }
    }


}
